import {
  type ApplySchemaAttributes,
  ExtensionTag,
  MarkExtension,
  type MarkExtensionSpec,
  type MarkSpecOverride,
} from 'remirror';

export class StreamCaretExtension extends MarkExtension {
  get name() {
    return 'caret' as const;
  }

  createTags() {
    return [ExtensionTag.FormattingMark, ExtensionTag.FontStyle];
  }

  createMarkSpec(
    extra: ApplySchemaAttributes,
    override: MarkSpecOverride
  ): MarkExtensionSpec {
    return {
      ...override,
      attrs: extra.defaults(),
      parseDOM: [
        {
          tag: 'caret',
          getAttrs: extra.parse,
        },
        ...(override.parseDOM ?? []),
      ],
      toDOM: () => {
        return [
          'span',
          {
            class: 'streaming-caret',
          },
          0,
        ];
      },
    };
  }
}
